import { Component, OnInit, Input, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OrderModel } from 'src/app/store/order/model';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-order-title',
  templateUrl: './order-title.component.html',
  styleUrls: ['./order-title.component.scss'],
  standalone: false,
})
export class OrderTitleComponent implements OnInit {
  translate = inject(TranslateService);
  private titleService = inject(Title);

  @Input() order: OrderModel;

  ngOnInit(): void {
    // Page title
    this.translate.get('TITLE_ORDER_PAGE').subscribe(page => {
      this.titleService.setTitle(page + ' ' + this.order.service.value);
    });
  }
}
